(() => {
  const CONFIG = {
    debug: true,

    

    normalVariantIds: [],

    serialGroupAvariantIds: [
       '43646399381622',
      '43646399479926',
      '43646399578230'
    ],

    serialGroupBvariantIds: [
      '43646399512694',
      '43646399545462',
      '43646399578230'
    ],


    serialPropertyName: 'Serial Number'
  };

  const STATE = {
    pendingForm: null,
    pendingVariantId: null,
    pendingQuantity: 1,
  };

  function log(...args) {
    if (CONFIG.debug) {
      console.log('[Serial Validation]', ...args);
    }
  }

  function getVariantRule(variantId) {
    const id = String(variantId);

    if (CONFIG.normalVariantIds.map(String).includes(id)) {
      return {
        requiresSerial: false,
        group: 'normal'
      };
    }

    if (CONFIG.serialGroupAvariantIds.map(String).includes(id)) {
      return {
        requiresSerial: true,
        group: 'group_a'
      };
    }

    if (CONFIG.serialGroupBvariantIds.map(String).includes(id)) {
      return {
        requiresSerial: true,
        group: 'group_b'
      };
    }

    return {
      requiresSerial: false,
      group: 'unknown'
    };
  }

  function getProductForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function getSelectedVariantId(form) {
    const idInput = form.querySelector('[name="id"]');
    return idInput ? String(idInput.value) : null;
  }

  function getQuantity(form) {
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = quantityInput ? Number(quantityInput.value) : 1;

    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }


  function openSerialModal() {
    const modal = document.getElementById('serialValidationModal');
    const input = document.getElementById('serialNumberInput');

    if (!modal) return;

    clearSerialError();

    if (input) {
      input.value = '';
    }

    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('upsell-modal-open');

    setTimeout(() => {
      input?.focus();
    }, 50);
  }

  function closeSerialModal() {
    const modal = document.getElementById('serialValidationModal');

    if (!modal) return;

    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('upsell-modal-open');

    STATE.pendingForm = null;
    STATE.pendingVariantId = null;
    STATE.pendingQuantity = 1;
  }

  function showSerialError(message) {
    const errorEl = document.getElementById('serialValidationError');

    if (!errorEl) return;

    errorEl.textContent = message || 'Unable to validate serial number.';
    errorEl.classList.add('is-visible');
  }

  function clearSerialError() {
    const errorEl = document.getElementById('serialValidationError');

    if (!errorEl) return;

    errorEl.textContent = '';
    errorEl.classList.remove('is-visible');
  }

  function setSubmitLoading(isLoading) {
    const button = document.getElementById('serialValidationSubmit');

    if (!button) return;

    button.disabled = isLoading;
    button.textContent = isLoading
      ? 'Validating...'
      : 'Validate and Add to Cart';
  }

  async function validateSerialNumber({ serialNumber, variantId, group }) {
    const response = await fetch(`https://integrations.ricoma.com/api/v1/shop/orders/sync/${serialNumber}`, {
      method: 'GET',
    });

    let data = null;

    try {
      data = await response.json();
    } catch (_) {
      data = null;
    }

    if (!response.ok) {
      return {
        valid: false,
        message: data?.message || 'Serial number could not be validated.',
        raw: data
      };
    }

    return {
      valid: true,
      message: data?.message || '',
      raw: data
    };
  }

  function passesGroupAValidation(validationResult) {
    const data = validationResult.raw || {};
    return validationResult.valid === true && data.valid !== false;
  }

  function passesGroupBValidation(validationResult) {
    const data = validationResult.raw || {};
    return (
      validationResult.valid === true &&
      data.valid !== false &&
      data.eligibleForUpgrade === true
    );
  }

  async function addVariantToCart({ variantId, quantity, serialNumber }) {
    const item = {
      id: Number(variantId),
      quantity: Number(quantity) || 1,
      properties: {
        [CONFIG.serialPropertyName]: serialNumber
      }
    };

    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [item]
      })
    });

    let data = null;

    try {
      data = await response.json();
    } catch (_) {
      data = null;
    }

    if (!response.ok) {
      throw new Error(data?.description || data?.message || 'Unable to add item to cart.');
    }

    return data;
  }

  function submitFormNormally(form) {
    /**
     * Para las variantes normales, no intervenimos.
     * El form sigue su comportamiento normal.
     */
    form.submit();
  }

  function onProductFormSubmit(event) {
    const form = event.target;

    if (!form.matches('form[action*="/cart/add"]')) return;

    const variantId = getSelectedVariantId(form);

    if (!variantId) return;

    const rule = getVariantRule(variantId);

    log('submit detected', {
      variantId,
      rule
    });

    if (!rule.requiresSerial) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    STATE.pendingForm = form;
    STATE.pendingVariantId = variantId;
    STATE.pendingQuantity = getQuantity(form);

    openSerialModal();
  }

  async function onSerialSubmit() {
    const input = document.getElementById('serialNumberInput');
    const serialNumber = input?.value?.trim();

    if (!serialNumber) {
      showSerialError('Please enter a serial number.');
      return;
    }

    if (!STATE.pendingVariantId) {
      showSerialError('No product variant selected.');
      return;
    }

    const rule = getVariantRule(STATE.pendingVariantId);

    try {
      clearSerialError();
      setSubmitLoading(true);

      const validationResult = await validateSerialNumber({
        serialNumber,
        variantId: STATE.pendingVariantId,
        group: rule.group
      });

      log('validation result', validationResult);

      let isAllowed = false;

      if (rule.group === 'group_a') {
        isAllowed = passesGroupAValidation(validationResult);
      }

      if (rule.group === 'group_b') {
        isAllowed = passesGroupBValidation(validationResult);
      }

      if (!isAllowed) {
        showSerialError(
          validationResult.message ||
          'This serial number is not eligible for this product.'
        );
        return;
      }

      await addVariantToCart({
        variantId: STATE.pendingVariantId,
        quantity: STATE.pendingQuantity,
        serialNumber,
      });

      closeSerialModal();

      /**
       * Puedes cambiar esto según tu theme:
       * - window.location.href = '/cart';
       * - window.location.reload();
       * - abrir cart drawer custom
       */
      window.location.href = window.Shopify.routes.root + 'cart';

    } catch (error) {
      console.error('[Serial Validation] error:', error);
      showSerialError(error.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitLoading(false);
    }
  }

  function init() {
    document.addEventListener('submit', onProductFormSubmit, true);

    document
      .getElementById('serialValidationSubmit')
      ?.addEventListener('click', onSerialSubmit);

    document
      .querySelectorAll('[data-serial-modal-close]')
      .forEach((el) => {
        el.addEventListener('click', closeSerialModal);
      });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeSerialModal();
      }
    });

    log('initialized');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();